import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import defaultStyles from 'index.module.css';
import { Footer } from 'components/footer/Footer';
import { Header } from 'components/header/Header';
import { Popup } from 'components/popup/Popup';
import { useScrollPosition } from 'hooks/localStorage.hooks';
import { ContactFormBookEventLazy } from 'components/contactFormBookEvent/ContactFormBookEventLazy';
import { VideoPlayerProvider } from 'components/fullscreenPlayer/videoContext';

const DefaultLayout = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    useScrollPosition();
    const openClosePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };
    return (
        <>
            <Header openClosePopup={openClosePopup} />
            <main className={defaultStyles.mainContent}>
                <VideoPlayerProvider>
                    <Outlet />
                </VideoPlayerProvider>
            </main>
            <Footer />
            <Popup isOpen={isPopupOpen} onClose={openClosePopup}>
                <ContactFormBookEventLazy onClose={openClosePopup} />
            </Popup>
        </>
    );
};

export default DefaultLayout;
